import { sectorChoices } from '@/services/sectors'
import { stages } from '@/services/startup-stages'
import { COUNTRIES_CHOICES } from '@/services/countries'
import BUSINESS_TYPES from '@/services/business-types'
import PRODUCT_TYPES from '@/services/product-types'
import { entries } from 'lodash'
import { initialQuestionsMap } from '@/services/faq-initial-sections'

const QUESTIONS = {
  caption: {
    label: 'Short description',
    type: 'TEXT',
    text: 'Describe your company in 1 sentence',
  },
  country: {
    label: 'Country',
    type: 'SINGLE_CHOICES',
    widget: 'DROPDOWN',
    widget_opts: {},
    text: "What is your company's country?",
    choices: COUNTRIES_CHOICES,
  },
  city: {
    label: 'City',
    type: 'TEXT',
    text: "What is your company's city?",
  },
  founded_at: {
    label: 'Founding date',
    type: 'YEAR_MONTH',
    text: 'When did you start working on the project/ found your company?',
  },
  employees_count: {
    label: 'Employees number',
    type: 'NUMBER',
    text: "What is your company's employees number?",
  },
  stage: {
    label: 'Stage',
    type: 'SINGLE_CHOICES',
    widget: 'DROPDOWN',
    text: "What is your company's stage?",
    choices: stages,
  },
  sectors: {
    label: 'Sectors',
    type: 'MULTIPLE_CHOICES',
    text: "What are your company's sectors?",
    choices: sectorChoices,
    widget: 'DROPDOWN',
  },
  business_type: {
    label: 'Business type',
    type: 'MULTIPLE_CHOICES',
    widget: 'DROPDOWN',
    text: "What is your company's business type?",
    choices: BUSINESS_TYPES,
  },
  product_type: {
    label: 'Product type',
    type: 'MULTIPLE_CHOICES',
    widget: 'DROPDOWN',
    text: "What is your company's product type?",
    choices: PRODUCT_TYPES,
  },
  logo_url: {
    label: 'Logo',
    type: 'IMAGE',
    text: "Please upload your company's logo",
  },
  website: {
    label: 'Website',
    type: 'TEXT',
    text: "Please attach your company's website link",
  },
  facebook: {
    label: 'Facebook',
    type: 'TEXT',
    text: "Please attach your company's Facebook link",
  },
  twitter: {
    label: 'Twitter',
    type: 'TEXT',
    text: "Please attach your company's Twitter link",
  },
  linkedin: {
    label: 'Linkedin',
    type: 'TEXT',
    text: "Please attach your company's Linkedin link",
  },

  faq_problem: {
    label: 'Problem',
    text: initialQuestionsMap.problem.text,
    type: 'TEXT',
  },

  faq_solution: {
    label: 'Solution',
    text: initialQuestionsMap.solution.text,
    type: 'TEXT',
  },

  faq_product: {
    label: 'Product',
    text: initialQuestionsMap.product.text,
    type: 'TEXT',
  },

  faq_key_innovation: {
    label: 'Key innovation',
    text: initialQuestionsMap.key_innovation.text,
    type: 'TEXT',
  },

  faq_target_market: {
    label: 'Target market',
    text: initialQuestionsMap.target_marked.text,
    type: 'TEXT',
  },

  faq_market_moment: {
    label: 'Market moment',
    text: initialQuestionsMap.market_moment.text,
    type: 'TEXT',
  },

  faq_competitors: {
    label: 'Competitors',
    text: 'Who are your main competitors and why are you better?',
    type: 'TEXT',
  },

  faq_go_to_market_strategy: {
    label: 'Go-to-market strategy',
    text: initialQuestionsMap.go_to_market_strategy.text,
    type: 'TEXT',
  },

  faq_buisness_model: {
    label: 'Business model',
    text: initialQuestionsMap.business_model.text,
    type: 'TEXT',
  },

  faq_buisness_risks: {
    label: 'Business risks',
    text: initialQuestionsMap.business_risks.text,
    type: 'TEXT',
  },

  faq_traction: {
    label: 'Traction',
    text: initialQuestionsMap.traction.text,
    type: 'TEXT',
  },

  faq_revenues: {
    label: 'Revenues',
    text: 'Do you generate revenues? What are your annual and monthly revenues?',
    type: 'TEXT',
  },

  faq_raised_capital: {
    label: 'Raised capital',
    text: 'How much capital have you raised so far and from whom?',
    type: 'TEXT',
  },

  faq_fundraising: {
    label: 'Fundraising',
    text: 'How much are you raising in the current round and what for?',
    type: 'TEXT',
  },

  faq_milestones: {
    label: 'Milestones',
    text: initialQuestionsMap.milestones.text,
    type: 'TEXT',
  },

  faq_founders_number: {
    label: 'Founders number',
    text: 'How many founders does the company have?',
    type: 'NUMBER',
  },

  faq_team_experience: {
    label: 'Team experience',
    text: 'Who are the founders and key team members? What is their background and experience?',
    type: 'TEXT',
  },

  faq_pitch_deck: {
    label: 'Pitch Deck',
    text: 'Please attach your Pitch Deck',
    type: 'ATTACHMENT',
  },
}

export default QUESTIONS

export const PROFILE_ATTRS = entries(QUESTIONS).map((pair) => {
  const [name, question] = pair
  return { name, label: question.label }
})

export function profileAttrLabel(attr) {
  const profileAttrDefinition = QUESTIONS[attr]
  return profileAttrDefinition.label
}

export function profileAttrQuestion(attr) {
  const profileAttrDefinition = QUESTIONS[attr]
  return profileAttrDefinition.text
}
